export enum VisibilityOptionEnum {
  DESCRIPTION = 'Description',
  PRODUCT_COUNT = 'Products count',
  MINIMAL_PRICE = 'Minimal price'
}

export type VisibilityOption = `${VisibilityOptionEnum}`;
